module.exports = __webpack_public_path__ + "static/produkty_mala-1da22f56c7b7f45d3fb504fb8867957c.png";